import Axios from '../../axiosConfig';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import NewsArticle from '../../types/news';
import { BACKEND_URL } from '../../config';

configure({ enforceActions: 'observed' });

/**Provides news related variables and methods */
export default class NewsModule {
    private news: NewsArticle[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public async fetchAllNews(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'news/all',
            withCredentials: true,
        });
        if (response?.status === 200) {
            const sorted = response.data.sort((a: NewsArticle, b: NewsArticle) => {
                return b.dateCreated! - a.dateCreated!;
            });
            runInAction(() => (this.news = sorted));
        }
    }

    public async removeNews(id: number): Promise<void> {
        await Axios({
            method: 'DELETE',
            url: BACKEND_URL + `news/delete/${id}`,
            withCredentials: true,
        });
        runInAction(() => {
            this.news = this.news.filter((article) => article.id !== id);
        });
    }

    public async saveNews(title: string, content: string): Promise<void> {
        const newsObject = {
            id: null,
            title: title,
            content: content,
            dateCreated: null,
        };

        const response = await Axios({
            method: 'POST',
            url: BACKEND_URL + 'news/add',
            data: newsObject,
            withCredentials: true,
        });

        const savedArticle = response.data;
        runInAction(() => {
            this.news.unshift(savedArticle);
        });
    }

    public get newsArticles(): NewsArticle[] {
        return this.news;
    }
}
